//Users
export const Save_User = (data) => ({
  type: "Save_User",
  payload: data,
});

export const Update_User = (data) => ({
  type: "Update_User",
  payload: data,
});

export const Remove_User = () => ({
  type: "Remove_User",
});

//Games
export const Save_Games_Data = (data) => ({
  type: "Save_Games_Data",
  payload: data,
});

export const Save_Property = (data) => ({
  type: "Save_Property",
  payload: data,
});

export const Select_Property = (data) => ({
  type: "Select_Property",
  payload: data,
});

//Cart
export const Set_Cart_Modal_Open = (isOpen) => ({
  type: "Set_Cart_Modal_Open",
  payload: isOpen,
});